/**
 * Map Invoices CODE
 */
const invoiceStatus = {
  SIN_EMITIR: 1,
  PENDIENTE_EMISION: 2,
  PENDIENTE_LEER: 3,
  ERROR_EMISISION: 4,
  LEIDA: 5,
  ACEPTADA: 6,
  RECHAZADA: 7,
  COBRO_EXTERNO: 8,
  EMITIDO_COBRO: 9,
  PAGO_EXTERNO: 10,
  EMITIDO_PAGO: 11,
  COBRADA: 12,
  PAGADA: 13,
  RECTIFICADA: 14,
  NOTIFICADA: 15,
  DESCARGADA_AUTOMATICAMENTE: 16,
  ENVIADA_A_PLATAFORMA_EXTERNA: 17,
  ACEPTADA_PLATAFORMA_EXTERNA: 18,
  RECHAZADA_PLATAFORMA_EXTERNA: 19,
  PRO_FORMA_ENVIADA: 20,
  PRO_FORMA_LEIDA: 21,
  PRO_FORMA_ACEPTADA: 22,
  PRO_FORMA_NOTIFICADA: 23,
  PRO_FORMA_RECHAZADA: 29,
  EN_CUSTODIA: 30,
  REGISTRADA: 31,
  EN_TRAMITE_DE_AUTORIZACION: 32,
  EN_TRAMITE_DE_PAGO: 33,
  GESTION_INCIDENCIA: 34,
  REGISTRADA_RCF: 35,
  CONTABILIZADA: 36,
  DEVUELTO_PAGADOR: 37,
  ANULADA: 38,
  ANULACION_SOLICITADA: 39,
  ANULACION_RECHAZADA: 40,
  ANULACION_ACEPTADA: 41
}

export const statusByType = {
  asPayerPending: [
    invoiceStatus.PENDIENTE_LEER,
    invoiceStatus.NOTIFICADA
  ],
  asPayerProcessed: [
    invoiceStatus.LEIDA,
    invoiceStatus.ACEPTADA,
    invoiceStatus.RECHAZADA,
    invoiceStatus.COBRO_EXTERNO,
    invoiceStatus.EMITIDO_COBRO,
    invoiceStatus.PAGO_EXTERNO,
    invoiceStatus.EMITIDO_PAGO,
    invoiceStatus.COBRADA,
    invoiceStatus.PAGADA,
    invoiceStatus.RECTIFICADA,
    invoiceStatus.DESCARGADA_AUTOMATICAMENTE,
    invoiceStatus.EN_CUSTODIA,
    invoiceStatus.REGISTRADA,
    invoiceStatus.EN_TRAMITE_DE_AUTORIZACION,
    invoiceStatus.EN_TRAMITE_DE_PAGO,
    invoiceStatus.REGISTRADA_RCF,
    invoiceStatus.CONTABILIZADA,
    invoiceStatus.DEVUELTO_PAGADOR,
    invoiceStatus.ANULADA,
    invoiceStatus.ANULACION_SOLICITADA,
    invoiceStatus.ANULACION_RECHAZADA,
    invoiceStatus.ANULACION_ACEPTADA
  ],
  asProviderPending: undefined, // Se cogen las de draft asi que no son necesarios estados
  asProviderSend: [
    invoiceStatus.PENDIENTE_LEER,
    invoiceStatus.LEIDA,
    invoiceStatus.ACEPTADA,
    invoiceStatus.RECHAZADA,
    invoiceStatus.COBRO_EXTERNO,
    invoiceStatus.EMITIDO_COBRO,
    invoiceStatus.PAGO_EXTERNO,
    invoiceStatus.EMITIDO_PAGO,
    invoiceStatus.COBRADA,
    invoiceStatus.PAGADA,
    invoiceStatus.RECTIFICADA,
    invoiceStatus.DESCARGADA_AUTOMATICAMENTE,
    invoiceStatus.REGISTRADA,
    invoiceStatus.EN_TRAMITE_DE_AUTORIZACION,
    invoiceStatus.EN_TRAMITE_DE_PAGO,
    invoiceStatus.GESTION_INCIDENCIA,
    invoiceStatus.REGISTRADA_RCF,
    invoiceStatus.CONTABILIZADA,
    invoiceStatus.ANULADA,
    invoiceStatus.ANULACION_SOLICITADA,
    invoiceStatus.ANULACION_RECHAZADA,
    invoiceStatus.ANULACION_ACEPTADA
  ],
  asProviderAccepted: [
    invoiceStatus.ACEPTADA,
    invoiceStatus.COBRO_EXTERNO,
    invoiceStatus.EMITIDO_COBRO,
    invoiceStatus.PAGO_EXTERNO,
    invoiceStatus.EMITIDO_PAGO,
    invoiceStatus.COBRADA,
    invoiceStatus.PAGADA,
    invoiceStatus.EN_TRAMITE_DE_AUTORIZACION,
    invoiceStatus.EN_TRAMITE_DE_PAGO,
    invoiceStatus.CONTABILIZADA
  ],
  asProviderReject: [
    invoiceStatus.RECHAZADA,
    invoiceStatus.ANULADA,
    invoiceStatus.ANULACION_SOLICITADA,
    invoiceStatus.ANULACION_RECHAZADA,
    invoiceStatus.ANULACION_ACEPTADA
  ]
}

export default invoiceStatus
